import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";

const NotifyModal = ({ openNotify, setOpenNotify, setOpenForm }) => {
  const handleSubscribe = () => {
    setOpenForm(true);
    setOpenNotify(false);
  };

  const { t } = useTranslation();

  return (
    <>
      <Transition.Root show={openNotify} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-[100]"
          onClose={() => setOpenNotify(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-[8px] bg-white dark:bg-[#252525] text-left shadow-xl transition-all p-5 gap-4 ">
                  <div className="flex">
                    <button onClick={() => setOpenNotify(false)}>
                      <IoCloseCircleOutline className="dark:text-white text-[25px]" />
                    </button>
                  </div>
                  <div className="flex justify-center">
                    <h1 className="font-semibold text-xl dark:text-white">
                      {t("You are not subscribed to the platform")}
                    </h1>
                  </div>
                  <div className="flex justify-center mb-1">
                    <p className="dark:text-white">
                      {t("Connect to your database to see your insights")}
                    </p>
                  </div>
                  <div className="text-center p-2">
                    <button
                      onClick={handleSubscribe}
                      className="w-[max-content] twrap mx-auto px-4 py-2 bg-[#5DA3E9] text-white text-[16px]  font-bold rounded-md flex items-center justify-center relative gap-[10px]"
                    >
                      {t("Subscribe to AUTONET")}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};
export default NotifyModal;
